import { Handle } from '@xyflow/react';

import {
  EdgeHandleTypeToColor,
  NODE_HANDLE_POSITION_STYLES,
  type NodeHandleProps,
} from './constants';

const NODE_HANDLE_SIZE_IN_PIXELS = 12;

export function ReadOnlyHandle(props: NodeHandleProps) {
  const { style, nodeProps, edgeHandleType, ...handleProps } = props;

  return (
    <Handle
      {...handleProps}
      style={{
        background: 'white',
        width: NODE_HANDLE_SIZE_IN_PIXELS,
        height: NODE_HANDLE_SIZE_IN_PIXELS,
        border: '2px solid',
        borderColor: EdgeHandleTypeToColor[edgeHandleType],
        ...NODE_HANDLE_POSITION_STYLES[props.position],
        ...style,
      }}
      isConnectable={false}
    />
  );
}
